package ai.wagemix.net.models

import ai.wagemix.net.models.firebase.WMFirebaseMix
import kotlin.time.Instant

/**
 * The area and industry a mix was built against. `null` means "all" (the API's id 1).
 */
interface WMMixFilters {
    val areaId: Int?
    val industryId: Int?

    companion object {
        val none: WMMixFilters = WMMixFiltersData(areaId = null, industryId = null)
    }
}

fun WMMixFilters.Companion.of(areaId: Int?, industryId: Int?): WMMixFilters = WMMixFiltersData(areaId, industryId)

private data class WMMixFiltersData(override val areaId: Int?, override val industryId: Int?): WMMixFilters

/**
 * A mix stored under `users/{uid}/storedMixes/{id}`: the Firestore document plus its id and
 * the metadata the redesign shows (created/modified times, the source file, the filters).
 * Rebuild plan task API-4 adds `modifiedAt` and `filters` to every writer.
 */
interface WMStoredMix {
    val id: String
    val title: String
    val occupations: List<WMFirebaseMix.Occupation>
    /** The upload this mix was generated from; `null` for a hand-built mix. */
    val fileId: String?
    val createdAt: Instant?
    val modifiedAt: Instant?
    val filters: WMMixFilters

    companion object
}

val WMStoredMix.fromJobDescription: Boolean
    get() = fileId != null

/** The most recent of the two timestamps, for "Updated Oct 18". */
val WMStoredMix.lastChangedAt: Instant?
    get() = modifiedAt ?: createdAt

fun WMStoredMix.Companion.of(
    id: String,
    title: String,
    occupations: List<WMFirebaseMix.Occupation>,
    fileId: String?,
    createdAt: Instant?,
    modifiedAt: Instant?,
    filters: WMMixFilters
): WMStoredMix = WMStoredMixData(id, title, occupations, fileId, createdAt, modifiedAt, filters)

private data class WMStoredMixData(
    override val id: String,
    override val title: String,
    override val occupations: List<WMFirebaseMix.Occupation>,
    override val fileId: String?,
    override val createdAt: Instant?,
    override val modifiedAt: Instant?,
    override val filters: WMMixFilters
): WMStoredMix
